define('modules/common/controller/IMieiDati',[], function() {
	var Controller = function($scope, Token, DatiCliente) {

		DatiCliente.getDenominazione().then(function(denominazione) {
			$scope.denominazione = denominazione;
		});

		DatiCliente.getRecapitoPrincipale().then(function(recapito) {
			$scope.recapito = recapito;
		});

		DatiCliente.getCodiceFiscale().then(function(cf) {
			$scope.cf = cf;
		});

		DatiCliente.getPartitaIva().then(function(piva) {
			$scope.piva = piva;
		});

		DatiCliente.getNascita().then(function(nascita) {
			$scope.luogonascita = nascita.luogonascita;
			$scope.datanascita = nascita.datanascita;
		});

	};

	return ["$scope", "Token", "DatiCliente", Controller];
});
